var map = {
	"./template.betgalaxy": 1076,
	"./template.betgalaxy.tsx": 1076,
	"./template.betprofessor": 2055,
	"./template.betprofessor.tsx": 2055,
	"./template.default": 408,
	"./template.default.tsx": 408,
	"./template.forsport": 1077,
	"./template.forsport.tsx": 1077,
	"./template.puntgenie": 2056,
	"./template.puntgenie.tsx": 2056,
	"./template.ts": 965,
	"./template.wellbet": 1982,
	"./template.wellbet.tsx": 1982
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2413;